import { DeleteOutlined } from '@ant-design/icons';
import { Divider, Button } from 'antd';
import { useContext } from 'react';

import { ClientFiltersContext } from '@app/providers';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

import type { FC } from 'react';

export const VisitsClearButton: FC<NClientsList.VisitsClearButtonProps> = ({
  filterGroupIndex,
}) => {
  const { clearVisitsGroup } = useContext(ClientFiltersContext);

  return (
    <div
      onClick={(e: MouseEvent | React.MouseEvent) => {
        e.stopPropagation();
        clearVisitsGroup(filterGroupIndex);
      }}
    >
      <Divider style={{ marginTop: '0px', marginBottom: '4px' }} />
      <Button
        className="clients-visits-clear-button"
        danger
        type="text"
        icon={<DeleteOutlined />}
      >
        Очистить
      </Button>
    </div>
  );
};
